// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sport-list-loader[data-v-a2c12c08]{padding:10px;background:var(--main-bg-color)}", "",{"version":3,"sources":["webpack://./src/components/Shared/SportListLoader.vue"],"names":[],"mappings":"AACA,oCACC,YAAA,CACA,+BAAA","sourcesContent":["\n.sport-list-loader {\n\tpadding: 10px;\n\tbackground: var(--main-bg-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
